import * as Sentry from "@sentry/tanstackstart-react";

export type MarketingCta = "start_for_free" | "see_how_it_works";

/**
 * Records a marketing CTA click in Sentry as a breadcrumb plus a lightweight
 * `info` event, tagged with the page and the section that produced the click so
 * conversions can be attributed to a specific part of the funnel.
 */
export function trackCtaClick(cta: MarketingCta, section: string) {
  const page = typeof window === "undefined" ? "unknown" : window.location.pathname;

  Sentry.addBreadcrumb({
    category: "marketing.cta",
    type: "user",
    level: "info",
    message: `${cta} clicked`,
    data: { cta, section, page },
  });

  Sentry.captureMessage(`cta.${cta}`, {
    level: "info",
    tags: {
      "cta.name": cta,
      "cta.section": section,
      "cta.page": page,
    },
    extra: { cta, section, page },
  });
}
